import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Heading.module.scss'

type Level = '1' | '2' | '3' | '4'
type Tone = 'default' | 'inherit'

interface HeadingProps {
  children: React.ReactNode
  level?: Level
  as?: 'h1' | 'h2' | 'h3' | 'h4'
  tone?: Tone
}

const levelMap: Record<Level, string> = {
  '1': styles.level1, '2': styles.level2, '3': styles.level3, '4': styles.level4,
}

const toneMap: Record<Tone, string> = {
  default: styles.toneDefault, inherit: styles.toneInherit,
}

export const Heading: React.FC<HeadingProps> = ({ children, level = '2', as, tone = 'default' }) => {
  const Tag = as ?? (`h${level}` as const)
  return <Tag className={cx(styles.heading, levelMap[level], toneMap[tone])}>{children}</Tag>
}
